var React = require('react');

function UploadDcpInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon / Upload DCP"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Icon-/-Upload-DCP","fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1","key":2},React.createElement("path",{"id":"Combined-Shape","fill":"#92999F","d":"M18,4 L22,4 L22,18 C22,19.1 21.1,20 20,20 L4,20 C2.9,20 2,19.1 2,18 L2.01,6 C2.01,4.9 2.9,4 4,4 L5,4 L7,8 L10,8 L8,4 L10,4 L12,8 L15,8 L13,4 L15,4 L17,8 L20,8 L18,4 Z M13,13.99 L16,13.99 L12,10 L8,13.99 L11,13.99 L11,18 L13,18 L13,13.99 Z"}))]);
}

UploadDcpInline.defaultProps = {"width":"24","height":"24","version":"1.1","viewBox":"0 0 24 24"};

module.exports = UploadDcpInline;

UploadDcpInline.default = UploadDcpInline;
